export default "__VITE_ASSET__CPiO0ubA__"